// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.Locations = {
  locationsHash: null,
  error: null,
  locationsFetched: false,
};
